import { Component, Input } from '@angular/core';
import { CmsFooterContactsProperties, CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CMSService } from '../Services/cms.service';
import { environment } from '../../environments/environment';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [RouterLink]
})
/** Footer component*/
export class FooterComponent {
  footerContacts: CmsFooterContactsProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
    /** Footer ctor */
  constructor(private cmsService: CMSService) {

  }
  logoPathCompany: string = "";
  phonetravels: string = "";
  addresstravels: string = "";
  emailtravels: string = "";
  currentYear: number = 0;
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.getdata();
  }
  getdata() {
    this.cmsService.getAllLoginPageData().subscribe((data) => {
    
      this.logoPathCompany = data.logo[0].logo;

    });
    this.cmsService.getFooterData().subscribe((data) => {


      this.footerContacts = data.footerContacts;
      this.phonetravels = this.footerContacts[0].details;
      this.emailtravels = this.footerContacts[2].details;
      this.addresstravels = this.footerContacts[1].details;

      this.footerSocial = data.footerSocial;

    });
  }
}
